import { Box } from '@material-ui/core';
import React from 'react';
import style from '../../../features/statistiques/css/Statistics.module.scss';
import classNames from 'classnames';

type Props = {
    label: string;
    bkgClass: string;
    color: string;
};

const CustomLegend: React.FC<Props> = ({ label, bkgClass, color }) => {
    return (
        <>
            <Box className="m-1" sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ flex: '1 1 auto' }} className={classNames(style.legend, bkgClass, style.legendScar)} />
                <Box className={classNames(style.legend, color)}>{label}</Box>
            </Box>
        </>
    );
};

export default CustomLegend;
